const STATUS_CHIP_TONES = {
    Present: "bg-success-soft text-success",
    Absent: "bg-danger-soft text-danger",
    Excused: "bg-warning-soft text-warning",
    "Double Session": "bg-brand-soft text-brand",
};

/** Tiny status pill used in the Recent Activity list. */
export default function StatusChip({ status }) {
    const label = status === "Double Session" ? "Double" : status;
    return (
        <span
            className={`px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wide shrink-0 ${
                STATUS_CHIP_TONES[status] || "bg-mist text-slate-600"
            }`}
        >
            {label}
        </span>
    );
}
